var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('Horizontal-menu',{staticClass:"horiMenu"}),_c('ConsolidatedProvince',{attrs:{"devices":_vm.devicesData,"province":_vm.province,"state":_vm.state,"causes":_vm.causesData,"actions":_vm.actionsData,"states":_vm.statesData,"loaderData":_vm.loaderData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }